import { useShouldWarnHedgeMark } from '@paradigm/features/src/unified-rfqs/ui/rfqs/hooks';

import HedgeMarkWarning from '#/components/rfq-common/HedgeMarkWarning';

export default function MaybeHedgeMarkWarn({
  className,
}: {
  className?: string;
}) {
  return useShouldWarnHedgeMark() ? (
    <HedgeMarkWarning className={className} />
  ) : null;
}
